<template>
    <canvas class="sfScreen" ref="sfScreen" @click="panelClick"></canvas>
</template>

<script>

const resizeEvent={
    addResizeListener(el,fn){
        if(!el.__ro__){
            el.__ro__= new ResizeObserver(fn);
            el.__ro__.observe(el)
        }
    },
    removeResizeListener(el){
        if(el.__ro__){
            el.__ro__.unobserve(el);
        }
    }
}
async function sleep(ms) {
    await new Promise(resolve => setTimeout(resolve, ms));
}

//食方ai 显示base64图片
export default {
    name:"sfScreen",
    props:{
        //是否触发点击
        isClickEvent:{
            type:Boolean,
            default:false
        }
    },
    data(){
        return {
            ctx:null,
            //图片数据流
            bitmapData:null,
            //通过 请求获取实时 数据流
            httpVideo:true,
            fps:100,
        }
    },
    mounted(){
        this.ctx = this.$refs.sfScreen.getContext("2d");
        this.$nextTick(()=>{
            resizeEvent.addResizeListener(this.$el, ()=>{
                this.setPanel();
            });
        })
        
    },
    methods:{
        /** */
        setPanel(){
            let rect=this.$el.getBoundingClientRect(); 
            if(rect?.width && this.$global.SFAiStatus){//是否显示
                let width=parseInt(rect.width);
                let height=parseInt(rect.height);
                const maxHeight=window.innerHeight-50;//最高多少
                if(maxHeight<height){
                    const per=Number((maxHeight/height).toFixed(4));
                    width=parseInt(width*per);
                    height=parseInt(height*per);
                }
                this.screenRect={
                    width:width,
                    height:height
                };
                this.$refs.sfScreen.width=width;
                this.$refs.sfScreen.height=height;
                this.$webBrowser.setPanelSize({x:rect.x,y:rect.y,width:width,height:height}).then(data=>{
                    if(data && (data.status==0 || data.state==0)){
                        console.log("位置大小设置成功");
                    }else{
                        console.log("位置大小设置失败",data);
                    }
                })
                this.renderLoop();
            }else{
                this._isLoop = false;
            }
        },
        getBase64(){
            return this.$webBrowser.getPanelBase64().then(data=>{
                if(data){
                    if(data.status==0 || data.state==0){
                        return data.data;
                    }else{
                        console.log("base64",data);
                    }
                }
            })
        },
        //获取图片
        async getImage(){
            return await new Promise((resolve,reject) =>{
                let img=new Image();
                img.src="host://video"+new Date().getTime();
                img.onload=()=>{
                    this.fps=1000/30;
                    resolve(img);
                }
                img.onerror=(e)=>{
                    this.fps=100;
                    reject(e);
                }
            });
            
        },
        // 解码Base64
        async getBitmap() {
            if(this.httpVideo){
                try {
                    return await this.getImage();
                } catch (error) {
                    console.log("通过请求 获取实时 图片数据方法无效");
                    this.httpVideo=false;
                }
            }

            const base64Data=await this.getBase64();
            if(base64Data){
                // 解码Base64
                const binary = atob(base64Data.includes(',') ?  base64Data.split(',')[1] : base64Data);
                const bytes = new Uint8Array(binary.length);
                for (let i = 0; i < binary.length; i++) {
                    bytes[i] = binary.charCodeAt(i);
                }
                const blob = new Blob([bytes], { type: 'image/jpeg' });
                return await createImageBitmap(blob);
            }
        },
        // 停止渲染
        stop() {
            this._isLoop = false;
        },
        /**开始渲染 */
        async renderLoop(){
            if(this._isLoop){
                return;
            }
            this._isLoop=true;
            await sleep(500);
            //第一次 预热拿一次
            await this.getImage().catch(()=>{});
            
            while(this._isLoop){
                const time=Date.now();//开始时间
                try {
                    let bitmap=await this.getImage();
                    if(bitmap){
                        this.drawImage(bitmap);
                    }
                    
                } catch (error) {
                    console.log(error);
                }

                const takeTime=Date.now()-time;//用时
                const delay= this.fps-takeTime;
                if(delay>0){
                    await sleep(delay);
                }
            }
        },
        /**绘制图片 */
        drawImage(bitmap){
            if(this.screenRect.width!=bitmap.width || this.screenRect.height!=bitmap.height){
                if(this._isLoop){
                    console.log("绘制图片尺寸不对 变更尺寸");
                    this.setPanel();
                }else{
                    console.log("绘制图片尺寸不对 不绘制");
                }
                return;
            }
            this.ctx.clearRect(0, 0, bitmap.width, bitmap.height);
            this.ctx.drawImage(bitmap, 0,0);
        },
        panelClick(e){
            if(this.isClickEvent){
                this.$webBrowser.panelClick({x:e.layerX,y:e.layerY}).then(data=>{
                    console.log("panelClick:",data)
                })
            }
        },
        //打开设置界面
        settingClick(){
            return this.$webBrowser.sendSFCMD(301,{show: "setting"}).then(d=>{
                if(d && (d.status==0 || d.state==0)){//
                    
                }else{
                    
                    this.$message.error("打开设置失败:"+(d?.message||""));
                }
                return d;
            });
        },
        //打开菜品设置
        setClick(){
            return this.$webBrowser.sendSFCMD(301,{show: "dish_management"}).then(d=>{
                console.log(d)
                if(d && (d.status==0 || d.state==0)){//
                    
                }else{
                    
                    this.$message.error("打开菜品设置失败:"+(d?.message||""));
                }
                return d;
            });
        },
        //重新识别
        reIdentify(){
            return this.$webBrowser.sendSFCMD(202,'').then(d=>{
                if(d && (d.status==0 || d.state==0)){//
                    
                }else{
                    
                    this.$message.error("重新识别失败:"+(d?.message||""));
                }
                return d;
            });
        },
        //加购
        addCard(){
            return this.$webBrowser.sendSFCMD(200,'');
        }
    },
    unmounted(){
        resizeEvent.removeResizeListener(this.$el);
        
        this.stop();
    }
}
</script>

